import './ManageJobs.css';

import { useEffect, useState } from 'react';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import { Tag } from 'primereact/tag';
import { ToggleButton } from 'primereact/togglebutton';

import JobDetails from '../../components/jobDetails/JobDetails';

import { Can, PERMISSIONS } from '../../security';
import { departments } from '../../utils/helper/departments';
import { requestGetTalentsCatalog } from '../../services/wisdomServices/talentService';
import {
    requestGetJob,
    requestGetJobs,
    requestGetJobsDashboard,
    requestjobPipeline,
    requestUpdateJobStatus
} from '../../services/wisdomServices/jobServices';
import {
    requestGetJobApplicants,
    requestGetApplicantResume,
    requestUpdateTalentApplicantStatus,
    requestJobApplicationPipeline,
    requestUpdateTalentApplicantNote
} from '../../services/wisdomServices/jobApplications';

function ManageJobs() {
    const zammadGroupUrl = "https://quinndesk.sirius-support.com/#ticket/view/recruitment";

    const defaultApplicantsPagination = {
        totalPages: 0,
        pageNumber: 1,
        pageSize: 10,
        totalLoaded: 0,
        totalResults: 0,
        hasNextPage: false,
        hasPreviousPage: false,
    };

    const [loading, setLoading] = useState(false);
    const [updatingJob, setUpdatingJob] = useState(false);
    const [loadingJobDetails, setLoadingJobDetails] = useState(false);
    const [jobs, setJobs] = useState([]);
    const [selectedJobGroup, setSelectedJobGroup] = useState("OPEN");

    const [visibleSideBar, setVisibleSideBar] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const [jobApplicants, setJobApplicants] = useState([]);
    const [applicantsLoading, setApplicantsLoading] = useState(false);
    const [applicantsPagination, setApplicantsPagination] = useState(defaultApplicantsPagination);

    const [resumeDialogVisible, setResumeDialogVisible] = useState(false);
    const [resumeBlobUrl, setResumeBlobUrl] = useState(null);
    const [resumeLoading, setResumeLoading] = useState(false);
    const [selectedApplicantResume, setSelectedApplicantResume] = useState(null);
    const [resumeLoadingApplicantId, setResumeLoadingApplicantId] = useState(null);
    const [creatingApplicantPipelineId, setCreatingApplicantPipelineId] = useState(null);
    const [jobStats, setJobStats] = useState({
        totalJobs: 0,
        openPositions: 0,
        needsReview: 0,
        totalApplications: 0,
        applied: 0,
        inInterview: 0,
        hired: 0,
        rejected: 0
    });

    const [creatingPipeline, setCreatingPipeline] = useState(false);
    const [selectedWorkType, setSelectedWorkType] = useState("all");
    const [selectedDepartment, setSelectedDepartment] = useState("All Departments");
    const [jobTitle, setJobTitle] = useState("");
    const [showFilters, setShowFilters] = useState(false);
    const [skills, setSkills] = useState([]);
    const [selectedSkills, setSelectedSkills] = useState([]);

    const [noteDialogVisible, setNoteDialogVisible] = useState(false);
    const [selectedApplicantNote, setSelectedApplicantNote] = useState(null);
    const [noteDraft, setNoteDraft] = useState("");
    const [originalNote, setOriginalNote] = useState("");
    const [savingNote, setSavingNote] = useState(false);

    const defaultApplicantFilters = {
        search: "",
        status: "",
        location: "",
        skills: [],
        languages: [],
    };

    const [applicantFilters, setApplicantFilters] = useState(defaultApplicantFilters);
    const [languages, setLanguages] = useState([]);

    const status = [
        { label: "Interview", value: "InInterview" },
        { label: "Applied", value: "Applied" },
        { label: "Hired", value: "Hired" },
        { label: "Rejected", value: "Rejected" },
        { label: "Do Not Hire", value: "DoNotHire" },
    ];

    const applicantStatusOptions = [
        { label: "All Status", value: "" },
        { label: "Applied", value: "Applied" },
        { label: "Interview", value: "InInterview" },
        { label: "Hired", value: "Hired" },
        { label: "Rejected", value: "Rejected" },
        { label: "Do Not Hire", value: "DoNotHire" },
    ];

    const workType = [
        { value: "all", label: "All Types" },
        { value: "full_time", label: "Full-time" },
        { value: "part_time", label: "Part-time" }
    ];

    const jobStatusValues = [
        { value: "NOT_STARTED", label: "Not Started" },
        { value: "NEEDS_REVIEW", label: "Needs Review" },
        { value: "OPEN", label: "Open" },
        { value: "CLOSED", label: "Closed" }
    ];

    const metrics = [
        { label: "Total Jobs", value: jobStats.totalJobs, icon: "pi pi-briefcase", color: "#0BADDE" },
        { label: "Open", value: jobStats.openPositions, icon: "pi pi-folder-open", color: "#22c55e" },
        { label: "Needs Review", value: jobStats.needsReview, icon: "pi pi-search", color: "#f59e0b" },
        { label: "Applicants", value: jobStats.totalApplications, icon: "pi pi-users", color: "#6366f1" },
        { label: "applied", value: jobStats.applied, icon: "pi pi-send", color: "#0ea5e9" },
        { label: "Interview", value: jobStats.inInterview, icon: "pi pi-comments", color: "#8b5cf6" },
        { label: "Hired", value: jobStats.hired, icon: "pi pi-check-circle", color: "#16a34a" },
        { label: "Rejected", value: jobStats.rejected, icon: "pi pi-times-circle", color: "#ef4444" },
        { label: "Do Not Hire", value: jobStats.rejected, icon: "pi pi-times-circle", color: "#ef4444" }
    ];

    useEffect(() => {
        return () => {
            if (resumeBlobUrl) {
                URL.revokeObjectURL(resumeBlobUrl);
            }
        };
    }, [resumeBlobUrl]);

    useEffect(() => {
        loadData();
    }, []);

    const loadLanguages = async () => {
        try {
            const languagesList = await requestGetTalentsCatalog("LANGUAGE");
            setLanguages(languagesList);
        } catch (error) {
            console.error("Error loading languages: ", error);
        }
    };

    const handleOpenNoteDialog = (rowData) => {
        const currentNote = rowData.note || rowData.notes || "";
        setSelectedApplicantNote(rowData);
        setOriginalNote(currentNote);
        setNoteDraft(currentNote);
        setNoteDialogVisible(true);
    };

    const handleCloseNoteDialog = () => {
        setNoteDialogVisible(false);
        setSelectedApplicantNote(null);
        setNoteDraft("");
        setOriginalNote("");
    };

    const handleSaveApplicantNote = async () => {
        try {
            setSavingNote(true);
            const note = noteDraft.trim();
            await requestUpdateTalentApplicantNote(selectedApplicantNote.id, note);
            setJobApplicants((prev) =>
                prev.map((applicant) =>
                    applicant.id === selectedApplicantNote.id
                        ? {
                            ...applicant,
                            note,
                            notes: note,
                        }
                        : applicant
                )
            );
            handleCloseNoteDialog();
        } catch (error) {
            console.error("Error saving applicant note: ", error);
        } finally {
            setSavingNote(false);
        }
    };

    const clearFilters = () => {
        setJobTitle("");
        setSelectedDepartment("All Departments");
        setSelectedWorkType("all");
        setSelectedSkills([]);
        setSelectedJobGroup("OPEN");
    };

    const loadData = async () => {
        try {
            setLoading(true);
            await Promise.all([
                loadSkills(),
                loadLanguages(),
                loadJobs(),
                loadDashboards()
            ]);
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoading(false);
        }
    };

    const loadSkills = async () => {
        try {
            const skillsList = await requestGetTalentsCatalog("SKILL");
            setSkills(skillsList);
        } catch (error) {
            console.error("Error: ", error);
        }
    };

    const loadJobs = async () => {
        try {
            setLoading(true);
            const jobsList = await requestGetJobs();
            setJobs(jobsList.data);
        } catch (error) {
            setLoading(false);
            console.error("Error: ", error);
        } finally {
            setLoading(false);
        }
    };

    const loadDashboards = async () => {
        try {
            const response = await requestGetJobsDashboard();
            setJobStats(response);
        } catch (error) {
            console.error("Error: ", error);
        }
    };

    const loadJobApplicants = async (
        jobId,
        pageNumber = 1,
        pageSize = 100,
        filtersToApply = applicantFilters
    ) => {
        try {
            setApplicantsLoading(true);
            const response = await requestGetJobApplicants(
                jobId,
                0,
                filtersToApply,
                {
                    pageNumber,
                    pageSize,
                }
            );
            setJobApplicants(Array.isArray(response?.data) ? response.data : []);
            setApplicantsPagination(
                response?.pagination || {
                    totalPages: 0,
                    pageNumber,
                    pageSize,
                    totalLoaded: 0,
                    totalResults: 0,
                    hasNextPage: false,
                    hasPreviousPage: false,
                }
            );
        } catch (error) {
            console.error("Error loading applicants: ", error);
            setJobApplicants([]);
        } finally {
            setApplicantsLoading(false);
        }
    };

    const filteredJobs = jobs.filter((job) => {
        const isClosed = job.status?.toUpperCase() === "CLOSED";
        const groupMatch = selectedJobGroup === "CLOSED" ? isClosed : !isClosed;
        const titleMatch =
            job.jobTitle?.toLowerCase().includes(jobTitle.toLowerCase());
        const workTypeMatch =
            selectedWorkType === "all" ||
            job.employmentType?.toLowerCase().includes(selectedWorkType.replace("_", "-"));
        const departmentMatch =
            selectedDepartment === "All Departments" ||
            job.department?.includes(selectedDepartment);
        const skillsMatch =
            !selectedSkills.length ||
            selectedSkills.some(skill =>
                job.skills?.toLowerCase().includes(skill.toLowerCase())
            );
        return groupMatch && titleMatch && workTypeMatch && departmentMatch && skillsMatch;
    }).sort((a, b) => {
        const recentA = Number(a.recentApplication) || 0;
        const recentB = Number(b.recentApplication) || 0;

        return recentB - recentA;
    });

    const handleCloseApplicantsDialog = () => {
        setVisibleSideBar(false);
        setJobApplicants([]);
        setSelectedJob(null);
        setApplicantFilters(defaultApplicantFilters);
    };

    const handleOpenSidebar = async (rowData) => {
        setSelectedJob(rowData);
        setVisibleSideBar(true);
        setJobApplicants([]);
        setApplicantFilters(defaultApplicantFilters);
        await loadJobApplicants(rowData.id, 1, 10, defaultApplicantFilters);
    };

    const handleApplyApplicantFilters = async () => {
        if (!selectedJob?.id) return;
        await loadJobApplicants(
            selectedJob.id,
            1,
            applicantsPagination.pageSize,
            applicantFilters
        );
    };

    const handleClearApplicantFilters = async () => {
        if (!selectedJob?.id) return;
        setApplicantFilters(defaultApplicantFilters);
        await loadJobApplicants(
            selectedJob.id,
            1,
            applicantsPagination.pageSize,
            defaultApplicantFilters
        );
    };

    const handleStatusSelection = (rowData, newStatus) => {
        if (newStatus === rowData.status) return;
        if (newStatus === "DoNotHire") {
            confirmDialog({
                message: `Are you sure you want to mark ${rowData.fullName} as Do Not Hire?`,
                header: "Confirm Status Change",
                icon: "pi pi-exclamation-triangle",
                acceptLabel: "Yes",
                rejectLabel: "Cancel",
                acceptClassName: "p-button-danger",
                accept: () => handleStatusChange(rowData, newStatus),
            });
            return;
        }
        handleStatusChange(rowData, newStatus);
    };

    const handleStatusChange = async (rowData, newStatus) => {
        const applicantId = rowData.id;
        const previousStatus = rowData.status;
        setJobApplicants((prev) =>
            prev.map((applicant) =>
                applicant.id === applicantId
                    ? {
                        ...applicant,
                        status: newStatus,
                        isUpdatingStatus: true,
                    }
                    : applicant
            )
        );
        try {
            await requestUpdateTalentApplicantStatus(applicantId, newStatus);
            void loadDashboards();
        } catch (error) {
            console.error("Error updating applicant status:", error);
            setJobApplicants((prev) =>
                prev.map((applicant) =>
                    applicant.id === applicantId
                        ? {
                            ...applicant,
                            status: previousStatus,
                        }
                        : applicant
                )
            );
        } finally {
            setJobApplicants((prev) =>
                prev.map((applicant) =>
                    applicant.id === applicantId
                        ? {
                            ...applicant,
                            isUpdatingStatus: false,
                        }
                        : applicant
                )
            );
        }
    };

    const handleCreateApplicantPipeline = async (rowData) => {
        try {
            setCreatingApplicantPipelineId(rowData.id);
            await requestJobApplicationPipeline(rowData.id);
            if (selectedJob?.id) {
                await loadJobApplicants(
                    selectedJob.id,
                    applicantsPagination.pageNumber,
                    applicantsPagination.pageSize
                );
            }
        } catch (error) {
            console.error("Error creating applicant pipeline: ", error);
        } finally {
            setCreatingApplicantPipelineId(null);
        }
    };

    const handleOpenResumePreview = async (rowData) => {
        try {
            setResumeLoading(true);
            setResumeLoadingApplicantId(rowData.id);
            setSelectedApplicantResume(rowData);
            if (resumeBlobUrl) {
                URL.revokeObjectURL(resumeBlobUrl);
                setResumeBlobUrl(null);
            }
            const resumeBlob = await requestGetApplicantResume(rowData.id);
            const pdfBlob = new Blob([resumeBlob], { type: "application/pdf" });
            const fileUrl = URL.createObjectURL(pdfBlob);
            setResumeBlobUrl(fileUrl);
            setResumeDialogVisible(true);
        } catch (error) {
            console.error("Error opening resume: ", error);
        } finally {
            setResumeLoading(false);
            setResumeLoadingApplicantId(null);
        }
    };

    const handleCloseResumeDialog = () => {
        setResumeDialogVisible(false);
        if (resumeBlobUrl) {
            URL.revokeObjectURL(resumeBlobUrl);
            setResumeBlobUrl(null);
        }
        setSelectedApplicantResume(null);
    };

    const handleJobStatusChange = async (e, rowData) => {
        try {
            setUpdatingJob(true);
            const newStatus = e.value;
            await requestUpdateJobStatus(rowData.uuid, newStatus);
            setJobs(prev =>
                prev.map(job =>
                    job.uuid === rowData.uuid
                        ? { ...job, status: newStatus }
                        : job
                )
            );
            if (newStatus === 'OPEN') {
                await handleCreatePipeline(rowData.uuid);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setUpdatingJob(false);
        }
    };

    const handleOpenJobDetailsDialog = async (job) => {
        if (loadingJobDetails) return;
        try {
            setLoadingJobDetails(true);
            setSelectedJob(null);
            setOpenDialog(true);
            const jobDetails = await requestGetJob(job.uuid);
            setSelectedJob(jobDetails);
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingJobDetails(false);
        }
    };

    const handleJobUpdated = (updatedJob) => {
        setJobs(prev =>
            prev.map(job =>
                job.uuid === updatedJob.uuid ? updatedJob : job
            )
        );
    };

    const handleCreatePipeline = async (jobUuid) => {
        try {
            setCreatingPipeline(true);
            await requestjobPipeline(jobUuid);
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setCreatingPipeline(false);
            await loadJobs();
        }
    };

    const getStatusStyle = (status) => {
        const normalized = status?.toLowerCase();
        const statusMap = {
            open: {
                background: "#e6f7f1",
                color: "#0f9d6f"
            },
            closed: {
                background: "#fde8e8",
                color: "#dc2626"
            },
            not_started: {
                background: "#f1f5f9",
                color: "#64748b"
            },
            needs_review: {
                background: "#F6EDDC",
                color: "#F5A00A"
            }
        };
        return statusMap[normalized] || {
            background: "#f3f4f6",
            color: "#374151"
        };
    };

    const getInitials = (fullName = "") => {
        const names = fullName
            .trim()
            .split(" ")
            .filter(Boolean);
        if (names.length === 0) {
            return "";
        }
        const firstInitial = names[0].charAt(0);
        const lastInitial =
            names.length > 1
                ? names[names.length - 1].charAt(0)
                : names[0].charAt(1) || "";
        return `${firstInitial}${lastInitial}`.toUpperCase();
    };

    const headerTemplate = (
        <div className="jobs-card">
            <div className="jobs-header">
                <h2>Jobs</h2>
                <div className='job-header-action-btns-box'>
                    {showFilters && (
                        <Button
                            label="Clear"
                            icon="pi pi-times"
                            outlined
                            onClick={clearFilters}
                        />
                    )}
                    <ToggleButton
                        onLabel="Filters"
                        offLabel="Filters"
                        onIcon="pi pi-sliders-h"
                        offIcon="pi pi-sliders-h"
                        checked={showFilters}
                        onChange={(e) => setShowFilters(e.value)}
                        className="w-9rem"
                    />
                    <Button label="Refresh" icon="pi pi-refresh" outlined onClick={loadJobs} loading={loading} />
                </div>
            </div>
            <div className={`filters-container ${showFilters ? "open" : ""}`}>
                <div className="filter-group job-status-filter-group">
                    <label id="job-status-filter-label">Job Status</label>
                    <div className="job-status-group-selector" aria-labelledby="job-status-filter-label">
                        <SelectButton
                            value={selectedJobGroup}
                            options={[
                                { label: "Open", value: "OPEN" },
                                { label: "Closed", value: "CLOSED" }
                            ]}
                            onChange={(e) => {
                                if (e.value) setSelectedJobGroup(e.value);
                            }}
                            allowEmpty={false}
                            aria-label="Filter jobs by open or closed"
                        />
                    </div>
                </div>
                <div className="filter-group">
                    <label htmlFor="filter-job-title">Job Title</label>
                    <InputText
                        id="filter-job-title"
                        value={jobTitle}
                        onChange={(e) => setJobTitle(e.target.value)}
                        style={{ height: "50px" }}
                        placeholder="Search titles..."
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor='filter-work-type'>Work Type</label>
                    <Dropdown
                        inputId='filter-work-type'
                        value={selectedWorkType}
                        options={workType}
                        optionLabel='label'
                        optionValue='value'
                        onChange={(e) => setSelectedWorkType(e.value)}
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor='filter-departpament'>Department</label>
                    <Dropdown
                        inputId='filter-departpament'
                        value={selectedDepartment}
                        options={departments}
                        optionLabel='label'
                        optionValue='label'
                        onChange={(e) => setSelectedDepartment(e.value)}
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor="filters-skills">Skills</label>
                    <MultiSelect
                        inputId='filters-skills'
                        value={selectedSkills}
                        onChange={(e) => setSelectedSkills(e.value)}
                        options={skills}
                        optionLabel="value"
                        optionValue='value'
                        display="chip"
                        placeholder="Select skills"
                        maxSelectedLabels={3}
                        className="w-full md:w-20rem"
                    />
                </div>
            </div>
        </div>
    );

    const jobTitleBodyTemplate = (rowData) => {
        const style = getStatusStyle(rowData.status);
        const recentApplications = Number(rowData.recentApplication) || 0;
        const meta = `${rowData.department} · ${rowData.location} · ${rowData.employmentType}`;
        return (
            <div>
                <div>
                    <div className='jobs-table-job-details'>
                        <span
                            className='jobs-table-job-title'
                            onClick={() => handleOpenJobDetailsDialog(rowData)}
                        >
                            {rowData.jobTitle}
                        </span>
                        <Tag
                            value={rowData.status}
                            style={{
                                background: style.background,
                                color: style.color,
                                borderRadius: "999px",
                                padding: "4px 10px",
                                fontWeight: 500
                            }}
                        />
                        {recentApplications > 0 && (
                            <Tag
                                icon="pi pi-exclamation-circle"
                                value={`${recentApplications} new`}
                                className="job-recent-applications-tag"
                                title={`${recentApplications} new application${recentApplications === 1 ? "" : "s"} in the past 24 hrs`}
                            />
                        )}
                    </div>
                    <div>
                        <span>{meta}</span>
                    </div>
                </div>
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="jobs-table-action-colunm">
                <div>
                    <span>
                        {rowData.totalApplication} {rowData.totalApplication > 1 ? "applicants" : "applicant"}
                    </span>
                </div>
                <div>
                    <Dropdown
                        options={jobStatusValues}
                        value={rowData.status}
                        optionLabel='label'
                        optionValue='value'
                        onChange={(e) => handleJobStatusChange(e, rowData)}
                        loading={updatingJob}
                    />
                </div>
                <div>
                    <Button
                        className='jobs-table-action-btns'
                        label='Applicants'
                        icon="pi pi-eye"
                        onClick={() => handleOpenSidebar(rowData)}
                        disabled={rowData.totalApplication === 0}
                    />
                </div>
                <div>
                    {rowData.zammadGroupId > 0 && (
                        <Button
                            link
                            className='jobs-table-action-btns'
                            label='Open Pipeline'
                            icon="pi pi-share-alt"
                            onClick={() => window.open(zammadGroupUrl, '_blank', "noopener,noreferrer")}
                        />
                    )}
                </div>
            </div>
        );
    };

    const urlBodyTemplate = (url) => {
        if (!url) {
            return <span>-</span>;
        }
        return (
            <div className="urlCell">
                <Button
                    link
                    icon="pi pi-external-link"
                    onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
                    label="Open"
                />
            </div>
        );
    };

    const zammadUrlBodyTemplate = (rowData) => {
        const isCreatingPipelineForThisApplicant = creatingApplicantPipelineId === rowData.id;
        return(
            <div className="urlCell">
                {rowData?.zammadTicketUrl ? (
                    <Button
                        link
                        icon="pi pi-external-link"
                        onClick={() => window.open(rowData.zammadTicketUrl, "_blank", "noopener,noreferrer")}
                        label="Open"
                    />
                ): (
                    <Can permission={PERMISSIONS.jobsByUuidOpenPipeline_patch}>
                        <Button
                            loading={isCreatingPipelineForThisApplicant}
                            disabled={isCreatingPipelineForThisApplicant}
                            className="applicant-details-header-right-btns"
                            label="Create"
                            icon="pi pi-share-alt"
                            outlined
                            onClick={() => handleCreateApplicantPipeline(rowData)}
                        />
                    </Can>
                )}
            </div>
        )
    }

    const nameBodyTemplate = (rowData) => {
        return (
            <div className="applicantNameCell">
                <Avatar
                    label={getInitials(rowData.fullName)}
                    shape="circle"
                    className="applicantAvatar"
                    style={{
                        background: "linear-gradient(90deg, rgba(213, 228, 235, 1) 4%, rgba(193, 222, 224, 1) 28%, rgba(167, 209, 209, 1) 82%)",
                    }}
                />
                <span className="applicantNameText">
                    {rowData.fullName.trim() || "-"}
                </span>
            </div>
        );
    };

    const videoUrlBodyTemplate = (rowData) => {
        return urlBodyTemplate(rowData.videoUrl);
    };

    const resumeBodyTemplate = (rowData) => {
        if (!rowData.resume) {
            return <span>-</span>;
        }
        const isLoadingThisResume = resumeLoadingApplicantId === rowData.id;
        return (
            <Button
                label={resumeLoading ? "Loading..." : "View"}
                icon="pi pi-file-pdf"
                text
                severity="info"
                loading={isLoadingThisResume}
                disabled={isLoadingThisResume}
                onClick={() => handleOpenResumePreview(rowData)}
            />
        );
    };

    const statusBodyTemplate = (rowData) => {
        const isUpdatingStatus = Boolean(rowData.isUpdatingStatus);
        return (
            <div className="applicantStatusCell">
                <Dropdown
                    placeholder="Applicant Status"
                    options={status}
                    value={rowData.status}
                    optionValue="value"
                    optionLabel="label"
                    onChange={(e) => handleStatusSelection(rowData, e.value)}
                    loading={isUpdatingStatus}
                    disabled={isUpdatingStatus}
                    appendTo={document.body}
                />
            </div>
        );
    };

    const notesBodyTemplate = (rowData) => {
        const hasNote = Boolean((rowData.note || rowData.notes || "").trim());
        return (
            <Button 
                title="Notes"
                label={hasNote ? "View/Edit" : "Add Notes"}
                icon="pi pi-clipboard"
                outlined
                severity={hasNote ? "info" : "secondary"}
                onClick={() => handleOpenNoteDialog(rowData)}
            />
        );
    };

    const applicantsTableHeader = (
        <div className="applicantsTableHeader">
            <div className="applicantsTableFilters">
                <div className="applicantsTableJobInfo">
                    <span className="applicantsTableJobLabel">Job</span>
                    <h3 title={selectedJob?.jobTitle || ""}>
                        {selectedJob?.jobTitle || "Applicants"}
                    </h3>
                    <span className="applicantsTableJobCount">
                        {applicantsPagination.totalResults || 0} applicants
                    </span>
                </div>
                {/* FILTERS */}
                <div className='applicantsTableJobFilters'>
                    <div className="applicantsTableFilterField applicantsTableFilterName">
                        <label htmlFor="applicant-name-filter">Name</label>
                        <InputText
                            id="applicant-name-filter"
                            value={applicantFilters.search}
                            onChange={(e) =>
                                setApplicantFilters((prev) => ({
                                    ...prev,
                                    search: e.target.value,
                                }))
                            }
                            placeholder="Search name"
                        />
                    </div>
                    <div className="applicantsTableFilterField applicantsTableFilterStatus">
                        <label htmlFor="applicant-status-filter">Status</label>
                        <Dropdown
                            inputId="applicant-status-filter"
                            value={applicantFilters.status}
                            options={applicantStatusOptions}
                            optionLabel="label"
                            optionValue="value"
                            onChange={(e) =>
                                setApplicantFilters((prev) => ({
                                    ...prev,
                                    status: e.value,
                                }))
                            }
                            placeholder="All Status"
                        />
                    </div>
                    <div className="applicantsTableFilterField applicantsTableFilterLocation">
                        <label htmlFor="applicant-location-filter">City/Country</label>
                        <InputText
                            id="applicant-location-filter"
                            value={applicantFilters.location}
                            onChange={(e) =>
                                setApplicantFilters((prev) => ({
                                    ...prev,
                                    location: e.target.value,
                                }))
                            }
                            placeholder="Example: London"
                        />
                    </div>
                    <div className="applicantsTableFilterField applicantsTableFilterMulti">
                        <label htmlFor="applicant-skills-filter">Skills</label>
                        <MultiSelect
                            inputId="applicant-skills-filter"
                            className="applicantsFilterMultiSelect"
                            value={applicantFilters.skills}
                            options={skills}
                            optionLabel="value"
                            optionValue="value"
                            onChange={(e) =>
                                setApplicantFilters((prev) => ({
                                    ...prev,
                                    skills: e.value,
                                }))
                            }
                            placeholder="Select skills"
                            display="comma"
                            maxSelectedLabels={2}
                        />
                    </div>
                    <div className="applicantsTableFilterField applicantsTableFilterMulti">
                        <label htmlFor="applicant-languages-filter">Languages</label>
                        <MultiSelect
                            inputId="applicant-languages-filter"
                            className="applicantsFilterMultiSelect"
                            value={applicantFilters.languages}
                            options={languages}
                            optionLabel="value"
                            optionValue="value"
                            onChange={(e) =>
                                setApplicantFilters((prev) => ({
                                    ...prev,
                                    languages: e.value,
                                }))
                            }
                            placeholder="Select languages"
                            display="comma"
                            maxSelectedLabels={2}
                        />
                    </div>
                    <div className="applicantsTableFilterActions">
                        <Button
                            label="Clear"
                            icon="pi pi-times"
                            outlined
                            size="small"
                            onClick={handleClearApplicantFilters}
                            disabled={applicantsLoading}
                        />
                        <Button
                            label="Apply"
                            icon="pi pi-search"
                            size="small"
                            onClick={handleApplyApplicantFilters}
                            loading={applicantsLoading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className='manage-jobs-page'>
            <header className='manage-jobs-header'>
                <div className='manage-jobs-header-title'>
                    <h1>Job Requests Dashboard</h1>
                </div>
                <div className='manage-jobs-header-analytics'>
                    {metrics.map((metric, index) => (
                        <Card key={index} className="job-metric-card">
                            <div className="job-metric-content">
                                <div
                                    className="job-metric-icon"
                                    style={{ background: metric.color }}
                                >
                                    <i className={metric.icon}></i>
                                </div>
                                <div className="job-metric-info">
                                    <span className="job-metric-value">
                                        {metric.value}
                                    </span>
                                    <span className="job-metric-label">
                                        {metric.label}
                                    </span>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            </header>
            <div className="jobs-wrapper">
                <DataTable
                    key={selectedJobGroup}
                    className='manage-jobs-table'
                    header={headerTemplate}
                    loading={loading || creatingPipeline}
                    emptyMessage={selectedJobGroup === "OPEN" ? "No open jobs found" : "No closed jobs found"}
                    rowHover
                    value={filteredJobs}
                    paginator
                    rows={10}
                >
                    <Column body={jobTitleBodyTemplate}></Column>
                    <Column body={actionBodyTemplate}></Column>
                </DataTable>
            </div>
            <Dialog
                visible={visibleSideBar}
                onHide={handleCloseApplicantsDialog}
                header={applicantsTableHeader}
                style={{ width: "98vw" }}
                breakpoints={{ "960px": "95vw", "641px": "100vw" }}
                maximizable
                dismissableMask
                closeOnEscape
                modal
                className="applicantsDialog"
            >
                <DataTable
                    dataKey="id"
                    className="applicantsTable"
                    value={jobApplicants}
                    loading={applicantsLoading}
                    emptyMessage="No applicants"
                    footer={`Total Applicants: ${applicantsPagination.totalResults || 0}`}
                    paginator
                    lazy
                    first={(applicantsPagination.pageNumber - 1) * applicantsPagination.pageSize}
                    rows={applicantsPagination.pageSize}
                    totalRecords={applicantsPagination.totalResults}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    onPage={(e) => {
                        const nextPageNumber = e.page + 1;
                        const nextPageSize = e.rows;
                        if (selectedJob?.id) {
                            loadJobApplicants(selectedJob.id, nextPageNumber, nextPageSize);
                        }
                    }}
                    scrollable
                    scrollHeight="60vh"
                    tableStyle={{ minWidth: "1200px" }}
                >
                    <Column header="Name" body={nameBodyTemplate}></Column>
                    <Column header="Status" body={statusBodyTemplate}></Column>
                    <Column header="City/Country" field="city"></Column>
                    <Column header="Phone Number" field="phoneNumber"></Column>
                    <Column header="Skills" field="skills"></Column>
                    <Column header="Languages" field="languages"></Column>
                    <Column header="Resume" body={resumeBodyTemplate}></Column>
                    <Column header="Pipeline" body={zammadUrlBodyTemplate}></Column>
                    <Column header="Intro. Video" body={videoUrlBodyTemplate}></Column>
                    <Column header="Note" body={notesBodyTemplate}></Column>
                </DataTable>
            </Dialog>
            <Dialog
                visible={resumeDialogVisible}
                onHide={handleCloseResumeDialog}
                header={`Resume - ${selectedApplicantResume?.fullName}`}
                style={{ width: "80vw" }}
                breakpoints={{ "960px": "95vw", "641px": "100vw" }}
                maximizable
                dismissableMask
                closeOnEscape
            >
                <div className="resumePreviewContainer">
                    {resumeBlobUrl ? (
                        <iframe
                            src={resumeBlobUrl}
                            title="Resume preview"
                            className="resumePreviewFrame"
                        />
                    ) : (
                        <div className="resumePreviewLoading">
                            Loading resume...
                        </div>
                    )}
                </div>
            </Dialog>
            <Dialog
                visible={noteDialogVisible}
                onHide={handleCloseNoteDialog}
                header={`Notes - ${selectedApplicantNote?.fullName || ""}`}
                style={{ width: "520px" }}
                breakpoints={{ "641px": "95vw" }}
                modal
                dismissableMask
                closeOnEscape
            >
                <div className="applicantNoteDialogContent">
                    <label htmlFor="applicant-note-input" className="applicantNoteLabel">
                        Recruiter Notes
                    </label>
                    <InputTextarea
                        id="applicant-note-input"
                        value={noteDraft}
                        onChange={(e) => setNoteDraft(e.target.value)}
                        placeholder="Type notes about this applicant..."
                        rows={8}
                        autoResize
                        className="applicantNoteTextarea"
                    />
                    <div className="applicantNoteDialogFooter">
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            severity="secondary"
                            outlined
                            onClick={handleCloseNoteDialog}
                            disabled={savingNote}
                        />
                        <Can permission={PERMISSIONS.jobApplicationsByIdNotes_patch}>
                            <Button
                                label="Save"
                                icon="pi pi-check"
                                severity="success"
                                loading={savingNote}
                                disabled={
                                    savingNote ||
                                    !noteDraft.trim() ||
                                    noteDraft.trim() === originalNote.trim()
                                }
                                onClick={handleSaveApplicantNote}
                            />
                        </Can>
                    </div>
                </div>
            </Dialog>
            {openDialog && (
                <JobDetails
                    job={selectedJob}
                    visible={openDialog}
                    onHide={() => setOpenDialog(false)}
                    onJobUpdated={handleJobUpdated}
                />
            )}
        </div>
    );
}
export default ManageJobs;
